
import { compose, mdsWidget } from 'dojo/_base/declare';
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import template from './EditTable.html?raw';
import "../Edit/Edit";
import "../Button/Button";


//import DataItems = require("DataItems");

class EditTable extends compose(_LabelInputBase) {
    templateString: any = template;

    
    destroy() {
        let result = super.destroy.apply(this, arguments as any);
    }

    
//    postCreate(): void {
//        let self: any = this;
//        self.inherited(arguments);
//        this.addSubscription("/Global/Click", lang.hitch(this, this._onGlobalClick));

//        this.actionRegistry = {};

//        if (this.domNode.isConnected != true) {

//            aspect.after(this, "placeAt", lang.hitch(this, this._afterPlace));

//            this._domnodeObserver = new MutationObserver(lang.hitch(this, this._onDomnodeObserver));
//            this._domnodeObserver.observe(document.body, {
//                childList: true,
//                //attributeFilter:["isConnected"]
//            });
//        }

//        this.actionRegistry["moveup"] = {
//            actionname: "moveup",
//            callback: null,
//            use: false,
//            enabled: true,
//            title: TranslationHelpers.translate("General_Label_Sorting_MoveUp", true),
//            //hidden: false,
//            hideIfDisabled: false,
//            iconClass: "fas fa-chevron-circle-up",
//            position: 200
//        };
//        this.actionRegistry["movedown"] = {
//            actionname: "movedown",
//            callback: null,
//            use: false,
//            enabled: true,
//            title: TranslationHelpers.translate("General_Label_Sorting_MoveDown", true),
//            // hidden: false,
//            hideIfDisabled: false,
//            iconClass: "fas fa-chevron-circle-down",
//            position: 201
//        };
//        this.actionRegistry["view"] = {
//            actionname: "view",
//            callback: null,
//            use: false,
//            enabled: true,
//            title: TranslationHelpers.translate("General_Label_ShowView", true),
//            //hidden: false,
//            hideIfDisabled: false,
//            iconClass: "fas fa-eye",
//            position: 100,
//        };
//        this.actionRegistry["sync"] = {
//            actionname: "sync",
//            callback: null,
//            use: false,
//            enabled: true,
//            title: "General_Label_Update",
//            // hidden: false,
//            hideIfDisabled: false,
//            iconClass: "fas fa-sync",
//            position: 115,
//        };

//        this.actionRegistry["edit"] = {
//            actionname: "edit",
//            callback: null,
//            use: false,
//            enabled: true,
//            title: TranslationHelpers.translate("General_Edit", true),
//           // hidden: false,
//            hideIfDisabled: false,
//            iconClass: "fas fa-edit",
//            position: 110,
//        };
//        this.actionRegistry["select"] = {
//            actionname: "select",
//            callback: null,
//            use: false,
//            enabled: true,
//           // hidden: false,
//            hideIfDisabled: false,
//            iconClass: "far fa-circle",
//            position: 99999,
//        };
//        this.actionRegistry["delete"] = {
//            actionname: "delete",
//            callback: null,
//            use: false,
//            enabled: true,
//            title: TranslationHelpers.translate("General_Delete", true),
//            // hidden: false,
//            hideIfDisabled: false,
//            iconClass: "fas fa-trash warningTXT",
//            position: 99998
//        };

//        this.rowConfigs = [];
//        this.rowRegistry = [];
//        this.availableLayouts = [];

//        this.tableHeads = [];
//    }

//    startup(): void {
//        // required for dojo inheritance to call the superclass
//        let self: any = this;
//        self.inherited(arguments);

//        this.PitHelper._structureFormat = "json";

//        if (this.data && this.selectedLayout && !this.tableRoot) {
//            if (this.groupingProperty || this.rowSortingAttr) {
//                this.sortData();
//            }

//            this.drawTable();
//        }
//    }
}

export default mdsWidget(EditTable);
